module.exports = __webpack_public_path__ + "img/logo3.3e22dc9e.png";